import {
  LIST_PATIENT_CENTER_REQUEST,
  LIST_PATIENT_CENTER_SUCCESS,
  LIST_PATIENT_CENTER_FAIL,
  DETAIL_PATIENT_CENTER_REQUEST,
  DETAIL_PATIENT_CENTER_SUCCESS,
  DETAIL_PATIENT_CENTER_FAIL,
  UPDATE_PATIENT_CENTER_REQUEST,
  UPDATE_PATIENT_CENTER_SUCCESS,
  UPDATE_PATIENT_CENTER_FAIL,
  CONFIRM_PATIENT_CENTER_REQUEST,
  CONFIRM_PATIENT_CENTER_SUCCESS,
  CONFIRM_PATIENT_CENTER_FAIL
} from '../../constants/patient-center'

const initialState = {
  patientCenterList: [],
  rsvp: {},
  loadingList: false,
  loadingDetail: false,
  isAddressCollapse: false,
  loadingEdit: false,
  loadingConfirm: false
}

const patientCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_ADDRESS_COLLAPSE':
      return {
        ...state,
        isAddressCollapse: !state.isAddressCollapse
      }
    case LIST_PATIENT_CENTER_REQUEST:
      return {
        ...state,
        loadingList: true
      }
    case LIST_PATIENT_CENTER_SUCCESS:
      return {
        ...state,
        loadingList: false,
        patientCenterList: action.payload,
        pageable: action.pageable
      }
    case LIST_PATIENT_CENTER_FAIL:
      return {
        ...state,
        loadingList: false,
        patientCenterList: [],
        error: action.payload
      }
    case DETAIL_PATIENT_CENTER_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_PATIENT_CENTER_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        rsvp: action.payload
      }
    case DETAIL_PATIENT_CENTER_FAIL:
      return {
        ...state,
        loadingDetail: false,
        rsvp: action.dummy,
        error: action.payload
      }
    case UPDATE_PATIENT_CENTER_REQUEST:
      return {
        ...state,
        loadingEdit: true
      }
    case UPDATE_PATIENT_CENTER_SUCCESS:
      return {
        ...state,
        codeConfirm: action.payload?.code,
        loadingEdit: false
      }
    case UPDATE_PATIENT_CENTER_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingEdit: false
      }
    case CONFIRM_PATIENT_CENTER_REQUEST:
      return {
        ...state,
        loadingConfirm: true
      }
    case CONFIRM_PATIENT_CENTER_SUCCESS:
      return {
        ...state,
        codeConfirm: action.payload?.code,
        loadingConfirm: false
      }
    case CONFIRM_PATIENT_CENTER_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingConfirm: false
      }
    default:
      return state
  }
}

export default patientCenterReducer
